module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./client/app/description/description.component.scss
// module id = ./client/app/description/description.component.scss
// module chunks = main